import { render, staticRenderFns } from "./addPriceTag.vue?vue&type=template&id=a6409a7c&scoped=true&"
import script from "./addPriceTag.vue?vue&type=script&lang=js&"
export * from "./addPriceTag.vue?vue&type=script&lang=js&"
import style0 from "./addPriceTag.vue?vue&type=style&index=0&id=a6409a7c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6409a7c",
  null
  
)

export default component.exports